import { Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";

const CustomHospitalLevels = () => {
  return (
    <Grid container sx={design.Container}>
      <CustomText
        color="#782A9F"
        fontWeight={500}
        fontFamily="Nunito"
        textAlign="center"
        width="100%"
        sx={design.TextPrinc}
      >
        Fases del proyecto
      </CustomText>
      <CustomText
        color="#162E84"
        fontWeight={700}
        fontFamily="Nunito"
        textAlign="center"
        width="100%"
        sx={design.TextProyect}
      >
        Un proyecto que crece por etapas
      </CustomText>
      <CustomText
        color="#000000"
        fontWeight={600}
        fontFamily="Nunito"
        textAlign="center"
        width="100%"
        sx={design.TextDescription}
      >
        Cada etapa representa un paso firme hacia la construcción del hospital
        integral que nuestra comunidad necesita
      </CustomText>
      <Grid
        container
        size={design.grid12}
        justifyContent="center"
        mt={{ xs: -5, md: -24 }}
      >
        <ImageLoader
          src="https://centromedicomedam.com/IMG/centromedicoMEDAM/NivelesMEDAM.png"
          alt="niveles"
          width={1300}
        />
      </Grid>
    </Grid>
  );
};
export default CustomHospitalLevels;

const design = {
  Container: {
    position: "relative",
    overflow: "hidden",
    backgroundImage:
      "url('https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "0%",
  },
  TextPrinc: {
    fontSize: {
      xs: 20,
      sm: 24,
      md: 26,
      lg: 17,
    },
    lineHeight: 1.2,
    mt: 5,
  },
  TextProyect: {
    fontSize: {
      xs: 32,
      sm: 42,
      md: 52,
      lg: 55,
    },
    lineHeight: 1.1,
    mb: 2,
  },
  TextDescription: {
    fontSize: {
      xs: 15,
      sm: 17,
      md: 18,
      lg: 19,
    },
  },
  grid12: { xs: 12, sm: 12, md: 12, lg: 12 },
};
